import React, { Component } from 'react';
import ceo from './../assets/zeiseler.png';
import { Link } from 'react-router-dom';

class Home extends Component {
    
    render() {
        return (
            <section className="page home">
                <div id="featuredImage" className="featuredImage">
                    <div className="pageTitle">Wir kaufen Erbteile</div>
                </div>
                <h1 className="title">Wir kaufen Erbteile</h1>
                <p className="content">
                    Die Geschäftsführung der ERB-Kauf GmbH ist erfahren in der juristischen und kaufmännischen Bewertung von Erbteilkäufen und erstellt Ihnen maßgeschneiderte Angebote. Ihre Vorteile: Sie sparen sich lange Wartezeiten, ungeklärte Verbindlichkeiten, und Ausseinandersetzungen mit unwilligen oder noch unbekannten Miterben.
                </p>
                <Link to='/ueber-uns'>
                    <div className="btnContact">
                        Mehr erfahren
                    </div>
                </Link>
                <div className="lowerBox">
                    <h2>Unser Team</h2>
                    <div className="teamMember">
                        <div className="headShot"><img src={ceo} alt="Dr. Dirk Zeiseler" /></div>
                        <div className="name">Dr. Dirk Zeiseler</div>
                        <div className="details">Geschäftsführer</div>
                    </div>
                    {/* <div className="teamMember">
                        <div className="headShot"><img src={} alt="" /></div>
                        <div className="name"></div>
                        <div className="details">Prokuristin</div>
                    </div> */}
                </div>
            </section>
        );
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/pages/Home.js